import { render, staticRenderFns } from "./GanttTimeBoardChart.vue?vue&type=template&id=ce887f1e&"
import script from "./GanttTimeBoardChart.vue?vue&type=script&lang=js&"
export * from "./GanttTimeBoardChart.vue?vue&type=script&lang=js&"
import style0 from "./GanttTimeBoardChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports